import ProfileName from '@/components/profile/name';

export default ProfileName;
